import React, { useCallback } from "react";
import * as dayjs from "dayjs";
import { useTranslation } from "@/langs/useTranslation";
import { Button, Typography } from "@material-ui/core";
import { Tag } from "antd";
import DataTable from "@/components/DataTable";
import { useHistory } from "react-router-dom";
import { ReactRender } from "@/components/ReactRender";
import { getNotificationList, updateNotificationAPI } from "@/apis/announcementApi";

const hideMessageContentTypes = ["Alarm Notification"];

export const TableContent = React.forwardRef(
  (
    { className, style, getSearchParams, children, onLoaded, onAction },
    ref
  ) => {
    const { t } = useTranslation();
    const history = useHistory();

    const columns = [
      {
        data: "json.type",
        title: t({ defaultMessage: "通知类型" }),
        // searchable: true,
        orderable: false,
        createdCell: (td, data) => {
          const tagTextMap = {
            "Alarm Notification": t({ defaultMessage: "报警通知" }),
            "Platform Notification": t({ defaultMessage: "平台公告" })
          };
          ReactRender(
            <Typography
              variant="body1"
              style={{
                maxWidth: 200,
                overflow: "hidden",
                textOverflow: "ellipsis"
              }}
            >
              {tagTextMap[data] || "-"}
            </Typography>,
            td
          );
        }
      },
      {
        data: "json.title",
        title: t({ defaultMessage: "标题" }),
        // searchable: true,
        orderable: false,
        createdCell: (td, data) => {
          ReactRender(
            <Typography
              variant="body1"
              style={{
                maxWidth: 200,
                overflow: "hidden",
                textOverflow: "ellipsis"
              }}
            >
              {data}
            </Typography>,
            td
          );
        }
      },
      {
        data: "json.message",
        orderable: false,
        title: t({ defaultMessage: "内容" }),
        createdCell: (td, data, record) => {
          ReactRender(
            <Typography
              variant="body1"
              style={{
                maxWidth: 200,
                overflow: "hidden",
                textOverflow: "ellipsis"
              }}
            >
              {hideMessageContentTypes.includes(record.json.type) ? (
                <Tag color="default">
                  {t({ defaultMessage: "内容请在详情查看" })}
                </Tag>
              ) : (
                data
              )}
            </Typography>,
            td
          );
        }
      },
      {
        data: "json.startTime",
        orderable: false,
        title: t({ defaultMessage: "开始时间" }),
        render: data => {
          if (data === "0" || Number(data) <= 0) return "-";
          return dayjs(Number(data)).format("YYYY-MM-DD HH:mm:ss");
        },
        name: "3"
      },
      {
        data: "json.endTime",
        orderable: false,
        title: t({ defaultMessage: "结束时间" }),
        render: data => {
          if (data === "0" || Number(data) <= 0) return "-";
          return dayjs(Number(data)).format("YYYY-MM-DD HH:mm:ss");
        },
        name: "4"
      },
      {
        data: "fromUserName",
        orderable: false,
        title: t({ defaultMessage: "发送人" })
      },
      {
        data: "createdAt",
        orderable: false,
        title: t({ defaultMessage: "发送时间" }),
        render: data => {
          if (!data || data === "0") return "-";
          return dayjs(Number(data)).format("YYYY-MM-DD HH:mm:ss");
        },
        name: "5"
      },
      {
        data: "id",
        name: "data.id",
        title: t({ defaultMessage: "操作" }),
        searchable: false,
        orderable: false,
        createdCell: (td, data) => {
          ReactRender(
            <>
              <Button
                type="button"
                color="primary"
                size="small"
                onClick={() => {
                  history.push(`/announcement-info/${data}`);
                }}
              >
                {t({ defaultMessage: "查看" })}
              </Button>
            </>,
            td
          );
        }
      }
    ];

    const ajax = (data, callback) => {
      let orderType;
      let orderWay;
      const order = data.order[0];
      if (order && data.columns[order.column]?.orderable) {
        orderType = data.columns[order.column]?.name;
        // orderType = order.column;
        orderWay = order.dir === "asc" ? 1 : 2;
      }
      return getNotificationList(100000, 2).then(res => {
        const search = getSearchParams();
        if (res.notificationListObjArr) {
          const list = res.notificationListObjArr
            .filter(item => {
              if (search.keywords) {
                return (
                  item.json.title.indexOf(search.keywords) > -1 ||
                  item.json.message.indexOf(search.keywords) > -1 ||
                  item.fromUserName.indexOf(search.keywords) > -1
                );
              }
              return true;
            })
            .filter(item => {
              if (search.startTime && search.endTime) {
                return (
                  Number(item.createdAt) > search.startTime &&
                  Number(item.createdAt) < search.endTime
                );
              }
              return true;
            })
            .filter(item => {
              if (search.isUnread) {
                return Number(item.readAt) < 0;
              }
              return Number(item.readAt) > 0;
            })
            .filter(item => {
              if (search.type) {
                return item.json.type === search.type;
              }
              return true;
            });

          callback({
            data: list.slice(
              (data.page - 1) * data.pageSize,
              data.page * data.pageSize
            ),
            recordsFiltered: list.length,
            recordsTotal: list.length
          });
        }
      });
    };

    const onRowClick = useCallback(
      (e, row) => {
        if (row && row.id) {
          updateNotificationAPI([row.id])
          history.push(`/announcement-info/${row.id}`);
        }
      },
      [history]
    );

    return (
      <DataTable
        ref={ref}
        ordering
        columns={columns}
        ajax={ajax}
        className={className}
        style={style}
        scrollable
        showCheckAll={false}
        onLoaded={onLoaded}
        onRowClick={onRowClick}
        defaultOrder={[]}
      >
        {children}
      </DataTable>
    );
  }
);
